import React, { useEffect, useState, useMemo } from "react";
import { getAllInternalUsers, updateInternalUser } from "../../../services/apiService";
import { showSnackbar } from "../../../comopnents/snackbar";

const InternalUsersList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  // Edit Modal States
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [form, setForm] = useState({
    mobile: "",
    email: "",
    module_assign: [],
  
  });
  const [saving, setSaving] = useState(false);

  // Fetch Users
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const data = await getAllInternalUsers();
      setUsers(data.Data || []);
    } catch (error) {
      console.error("Failed to fetch users:", error);
    } finally {
      setLoading(false);
    }
  };

  // Filtered Users (exclude dealers)
  const filteredUsers = useMemo(() => {
    return users.filter((u) =>
      u.usertype?.toLowerCase() !== "dealer" &&
      `${u.username} ${u.email} ${u.mobile}`.toLowerCase().includes(search.toLowerCase())
    );
  }, [users, search]);

  // Pagination
  const totalPages = Math.ceil(filteredUsers.length / pageSize);
  const paginatedUsers = useMemo(() => {
    const start = (page - 1) * pageSize;
    return filteredUsers.slice(start, start + pageSize);
  }, [filteredUsers, page, pageSize]);

  useEffect(() => setPage(1), [search]);

  if (loading)
    return <p style={{ textAlign: "center", marginTop: "2rem" }}>Loading...</p>;

  // Open Edit Modal
  const openEditModal = (user) => {
    setSelectedUser(user);
    setForm({
      mobile: user.mobile || "",
      email: user.email || "",
      module_assign: user.module_assign ? user.module_assign.split(",") : [],
      is_active:user.is_active
  
    });
    setEditModalVisible(true);
  };

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleCheckboxChange = (module) => {
    setForm(prev => {
      const modules = new Set(prev.module_assign);
      if (modules.has(module)) modules.delete(module);
      else modules.add(module);
      return { ...prev, module_assign: Array.from(modules) };
    });
  };

  const handleSave = async () => {
    if (!selectedUser) return;
    setSaving(true);

    const payload = {
      ...selectedUser,
      mobile: form.mobile,
      email: form.email,
      module_assign: form.module_assign.join(","),
      is_active: form.is_active ? true : false,
    };

    try {
      await updateInternalUser(selectedUser.id, payload);

      setUsers(prev =>
        prev.map(u => (u.id === selectedUser.id ? { ...u, ...payload } : u))
      );

      setEditModalVisible(false);
      showSnackbar("success", "User updated successfully!");
    } catch (err) {
      console.error(err);
      showSnackbar("error", "Failed to update user.");
    } finally {
      setSaving(false);
    }
  };

  const modulesList = [
    "dashboard",
    "products",
    "users",
    "customers",
    "inventory",
    "reports",
    "warehouse",
    "accounting",
    "telecalling",
    "discount",
    "comments",
    "orders",
    "settings",
    "blogs",
    "verificationlist",
  ];

  return (
    <div style={styles.container}>
      <h3 style={styles.title}>All Internal Users</h3>

      {/* Search */}
      <input
        type="text"
        placeholder="Search by username, email, mobile..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        style={styles.searchInput}
      />

      {/* Users Table */}
      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>ID</th>
            <th style={styles.th}>Username</th>
            <th style={styles.th}>Email</th>
            <th style={styles.th}>Mobile</th>
            <th style={styles.th}>User Type</th>
            <th style={styles.th}>Active</th>
            <th style={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.length > 0 ? (
            paginatedUsers.map(u => (
              <tr key={u.id} style={styles.tr}>
                <td style={styles.td}>{u.id}</td>
                <td style={styles.td}>{u.username}</td>
                <td style={styles.td}>{u.email}</td>
                <td style={styles.td}>{u.mobile}</td>
                <td style={styles.td}>{u.usertype}</td>
                <td style={styles.td}>{u.is_active ? "Yes" : "No"}</td>
                <td style={styles.td}>
                  <span
                    style={{ cursor: "pointer", color: "#0aa06e" }}
                    onClick={() => openEditModal(u)}
                  >
                    Edit
                  </span>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" style={{ textAlign: "center", padding: "20px" }}>
                No users found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Pagination */}

      <div className="pagination-container">


        <div style={{ color: "black" }}>

          Items per page:

          <select
            className="page-select"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
              setPage(1);
            }}
          >

            {[5, 10, 20, 50].map((n) => (
              <option key={n} value={n}>
                {n}
              </option>
            ))}

          </select>

        </div>



        <div className="page-buttons">

          <button
            className="page-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Previous
          </button>


          <span className="page-count">

            {page} / {totalPages || 1}

          </span>


          <button
            className="page-btn"
            disabled={page === totalPages || totalPages === 0}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>

        </div>


      </div>

      {/* Edit Modal */}
      {editModalVisible && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <h3>Edit Internal User</h3>

            <div style={styles.row}>
              <input value={selectedUser?.id} disabled style={styles.input} />
              <input value={selectedUser?.clientid} disabled style={styles.input} />
              <input value={selectedUser?.usertype} disabled style={styles.input} />
            </div>

            <div style={styles.row}>
              <input
                value={form.mobile}
                onChange={(e) => handleChange("mobile", e.target.value)}
                placeholder="Phone Number"
                style={styles.input}
                readOnly
              />
              <input
                value={form.email}
                onChange={(e) => handleChange("email", e.target.value)}
                placeholder="Email"
                style={styles.input}
                readOnly
              />
            </div>

            {selectedUser?.usertype !== "Customer" && (
              <div style={styles.modules}>
                {modulesList.map(module => (
                  <label key={module} style={styles.moduleLabel}>
                    <input
                      type="checkbox"
                      checked={form.module_assign.includes(module)}
                      onChange={() => handleCheckboxChange(module)}
                    />
                    {module}
                  </label>
                ))}
              </div>
            )}

            <label style={{ display: "block", margin: "10px 0" }}>
              <input
                type="checkbox"
                checked={form.is_active}
                onChange={(e) => handleChange("is_active", e.target.checked)}
              />
              Active
            </label>

            <div style={{ marginTop: "15px" }}>
              <button onClick={handleSave} disabled={saving} style={styles.saveBtn}>
                {saving ? "Saving..." : "Save changes"}
              </button>
              <button onClick={() => setEditModalVisible(false)} style={styles.cancelBtn}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: { margin: "2rem", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" },
  title: { marginBottom: "1rem", color: "#333" },
  searchInput: { marginBottom: "15px", padding: "8px", width: "300px", borderRadius: "4px", border: "1px solid #ccc" },
  table: { width: "100%", borderCollapse: "collapse", boxShadow: "0 2px 10px rgba(0,0,0,0.1)" },
  th: { padding: "12px", backgroundColor: "#005487", color: "white", textAlign: "left" },
  tr: { borderBottom: "1px solid #ddd" },
  td: { padding: "12px", color: "#555" },
  pagination: { marginTop: "15px", display: "flex", justifyContent: "space-between", alignItems: "center" },
  modalOverlay: { position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.4)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 },
  modal: { backgroundColor: "#fff", padding: "20px", borderRadius: "8px", width: "700px", height: "400px", overflowY: "auto" },
  row: { display: "flex", gap: "10px", marginBottom: "10px" },
  input: { flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" },
  modules: { display: "flex", flexWrap: "wrap", gap: "10px", margin: "10px 0" },
  moduleLabel: { display: "flex", alignItems: "center", gap: "5px" },
  saveBtn: { backgroundColor: "#0aa06e", color: "#fff", padding: "8px 15px", border: "none", borderRadius: "4px", marginRight: "10px", cursor: "pointer" },
  cancelBtn: { padding: "8px 15px", border: "1px solid #ccc", borderRadius: "4px", cursor: "pointer" }
};

export default InternalUsersList;